import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function Document({
  size = sizes.X_SMALL,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="-1 0 12 12"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M9.58808 3.00804L6.70594 0.125893C6.62558 0.0455357 6.5171 0 6.40326 0H0.713972C0.476918 0 0.2854 0.191518 0.2854 0.428571V11.5714C0.2854 11.8085 0.476918 12 0.713972 12H9.2854C9.52246 12 9.71397 11.8085 9.71397 11.5714V3.31205C9.71397 3.19821 9.66844 3.08839 9.58808 3.00804ZM8.72558 3.50893H6.20504V0.988393L8.72558 3.50893ZM8.74969 11.0357H1.24969V0.964286H5.29433V3.85714C5.29433 4.00633 5.35359 4.1494 5.45908 4.25489C5.56457 4.36038 5.70765 4.41964 5.85683 4.41964H8.74969V11.0357ZM4.89254 7.41964H2.42826C2.36933 7.41964 2.32112 7.46786 2.32112 7.52679V8.16964C2.32112 8.22857 2.36933 8.27679 2.42826 8.27679H4.89254C4.95147 8.27679 4.99969 8.22857 4.99969 8.16964V7.52679C4.99969 7.46786 4.95147 7.41964 4.89254 7.41964ZM2.32112 5.70536V6.34821C2.32112 6.40714 2.36933 6.45536 2.42826 6.45536H7.57112C7.63004 6.45536 7.67826 6.40714 7.67826 6.34821V5.70536C7.67826 5.64643 7.63004 5.59821 7.57112 5.59821H2.42826C2.36933 5.59821 2.32112 5.64643 2.32112 5.70536Z"
        fill={colour}
      />
    </svg>
  )
}

Document.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
